/* Configuración de la landing — equivalente a los props del .dc.html.
   En build, cualquiera de estos valores puede venir de una variable de entorno
   `VITE_*` (ver README) sin tocar el resto del código. */

export const CONFIG = {
  // prop `tourUrl` del template
  tourUrl:
    import.meta.env.VITE_TOUR_URL ||
    'https://tour360.jvelez.space/tour/6fe5f5eb-bad4-4162-9188-ec3b7155814d/embed?v=2',

  // Endpoint del formulario. Mientras sea null el envío se simula igual que
  // en el template de diseño: NO se entrega el mensaje a ningún lado.
  contactEndpoint: import.meta.env.VITE_CONTACT_ENDPOINT || null
};
